import { ProtoBaseModel, attr } from '@square/dashboard-data/utils/ember-model-stubs';
import QuantityRatio from '@square/dashboard-items-data/models/squareup/inventory/v3/quantity-ratio';
export default ProtoBaseModel.extend({
  quantity: attr(QuantityRatio),
  variationId: attr(String),
  compositionId: attr(String)
});